import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Een initiatief van", -1)
const _hoisted_2 = ["src"]




export default /*#__PURE__*/_defineComponent({
  __name: 'Initiator',
  props: {
  dark: {
    type: Boolean
  },
  smallText: {
    type: Boolean
  }
},
  setup(__props) {

const props = __props;



const src = require(`@/assets/img/${props.dark ? 'logo-dark.svg' : 'menu-logo.png'}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["info", { 'small-text': __props.smallText }]),
    href: "https://15augustus1945.nl/",
    target: "_blank"
  }, [
    _hoisted_1,
    _createElementVNode("img", {
      src: _unref(src),
      alt: "Nationale herdenking 15 augustus 1945"
    }, null, 8, _hoisted_2)
  ], 2))
}
}

})